import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
import { useTableContext } from "./context7.js";
function Divider() {
  const {
    columnsCount
  } = useTableContext();
  return /* @__PURE__ */ jsx(DividerRow, {
    children: /* @__PURE__ */ jsx(DividerCell, {
      colSpan: columnsCount
    })
  });
}
const DividerRow = styled.tr.withConfig({
  displayName: "DividerRow",
  componentId: "sc-2x6ca7-0"
})(["&:nth-child(2){display:none;}"]);
const DividerCell = styled.td.withConfig({
  displayName: "DividerCell",
  componentId: "sc-2x6ca7-1"
})(["padding:", " 0;&::before{content:'';display:block;height:1px;height:1px;background:", ";}"], token.spacing3, token.gray100a);
export {
  Divider
};
//# sourceMappingURL=Divider4.js.map
